<template>
  <v-app id="login" class="login-background">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs3 v-bind:style="{ 'margin-right': cardMargin + 'px' }">
          <v-card style="min-width: 200px;">
            <v-card dark color="primary">
              <v-card-text>
                <v-toolbar-title>Login</v-toolbar-title>
                <!-- <button
                                    v-if="isMobile"
                                    style="background-color:  #4caf50; color: #4caf50 !important"
                                    @click="goToMessages()"
                                >
                                    goToMessages
                                </button> -->
              </v-card-text>
            </v-card>

            <v-card-text class="pb-2">
              <v-form>
                <v-text-field
                  prepend-icon="mdi-account"
                  name="login"
                  label="Login"
                  type="text"
                  v-model="username"
                ></v-text-field>
                <v-text-field
                  prepend-icon="mdi-lock"
                  autocomplete
                  name="password"
                  label="Password"
                  id="password"
                  type="password"
                  v-model="password"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-layout column>
                <v-btn
                  class="mb-3"
                  dark
                  :loading="loggingIn"
                  color="green"
                  v-on:click="login()"
                  >Sign In</v-btn
                >
              </v-layout>
            </v-card-actions>

            <v-card-text v-if="invalidLogin" class="pt-0">
              <p class="text-danger">
                {{ loginError }}
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    username: "",
    password: "",
    name: "",
    invalidLogin: false,
    loggingIn: false,
    loginError: "",
    isMobile: false,
    cardMargin: "0",
  }),
  async created() {
    window.addEventListener("keyup", this.onKeyPressed);

    this.$store.dispatch("AUTH_LOGOUT");

    this.isMobile = window.innerWidth < 551;

    if (this.isMobile) {
      this.cardMargin = "125";
    }
  },
  destroyed() {
    window.removeEventListener("keyup", this.onKeyPressed);
  },
  methods: {
    onKeyPressed(e) {
      if (e.keyCode == 13) {
        this.login();
      }
    },
    goToMessages() {
      this.$router.push({
        name: "MessagesMobile",
      });
    },
    async login() {
      try {
        this.loggingIn = true;

        const user = await this.$store.dispatch("AUTH_REQUEST", {
          username: this.username,
          password: this.password,
        });

        const normalizedUser = this.$store.state.user
          ? this.$store.state.user.toLowerCase().trim()
          : "";

        if (normalizedUser == "saul") {
          this.$router.push({
            name: "Greetings",
          });

          return;
        }

        if (normalizedUser == "syw") {
          this.$router.push({
            name: "Recordings",
          });

          return;
        }

        if (this.isMobile) {
          this.$router.push({
            name: "MessagesMobile",
          });
        } else {
          this.$router.push({
            name: "MessagesNew",
          });
        }

        this.loggingIn = false;
      } catch (e) {
        this.loggingIn = false;

        this.invalidLogin = true;
        this.loginError = "Invalid Username Or Password";
      }
    },
  },
};
</script>
<style></style>
